import { useEffect } from "react";

import { useThreadShells } from "../state/entities";
import {
  assignThreadSpaceRequest,
  refreshOrgSpaces,
  takePendingThreadSpaces,
} from "../state/spaces";
import { toastManager } from "../components/ui/toast";

/**
 * Files a chat sent from Home into its space once the thread exists: the
 * composer queues the request (state/spaces requestThreadSpace) before the
 * chat view creates the thread; this runs at the shell, so it survives the
 * navigation and fires as soon as the new thread's shell arrives.
 */
export function usePendingThreadSpaces(): void {
  const threads = useThreadShells();
  useEffect(() => {
    const ready = takePendingThreadSpaces(new Set(threads.map((thread) => thread.id)));
    for (const pending of ready) {
      void assignThreadSpaceRequest(pending.threadId, pending.spaceId).then((error) => {
        if (error) {
          toastManager.add({ type: "error", title: "Couldn’t file the chat in its space", description: error });
          return;
        }
        refreshOrgSpaces(pending.organizationId);
      });
    }
  }, [threads]);
}
